import { useCallback } from "react";
import { delay } from "../../utils/delay";
import { useAxiosInstances } from "../axios-instance";
import {
  IAcesso,
  IAutenticacao,
  IExtendedUsuario,
} from "../../application/models";
import axios from "axios";

export const useAuthApi = () => {
  // Axios
  const { axiosAuthInstance } = useAxiosInstances();

  const insertAcessoApi = useCallback(
    async (data: {
      IdProduto: number;
      IdUsuario: number;
    }): Promise<{
      token: string;
      acesso: IAcesso;
      usuario: IExtendedUsuario;
    }> => {
      try {
        const result = await axiosAuthInstance.post("/auth/acesso", {
          IdProduto: data.IdProduto,
          IdUsuario: data.IdUsuario,
        });

        return {
          acesso: result.data.acesso,
          token: result.data.accessToken,
          usuario: result.data.usuario,
        };
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance],
  );

  const requeNewPasswordApi = useCallback(async (data: { email: string }) => {
    await delay(1551);
    return;
  }, []);

  const validateCodeApi = useCallback(
    async (data: { code: string }): Promise<boolean> => {
      await delay(1551);
      return true;
    },
    [],
  );

  const createNewPasswordApi = useCallback(
    async (data: {
      email: string;
      password: string;
      code: string;
    }): Promise<void> => {
      await delay(1551);
      return;
    },
    [],
  );

  const refreshApi = useCallback(async (token: string): Promise<{
    Autenticado: boolean;
    Mensagem: string;
    Token: string;
    [key: string]: any;
  }> => {
    try {
      const authUrl = process.env.REACT_APP_VELES_AUTH_URL;
      const response = await axios.get(
        `${authUrl}/api/validation/refreshTokenv3`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }, []);

  const fetchSessionConfigApi = useCallback(async (): Promise<{ sessionTimeoutSeconds: number }> => {
    try {
      const response = await axiosAuthInstance.get("/auth/session-timeout");
      return response.data;
    } catch (error) {
      return { sessionTimeoutSeconds: Number(process.env.SESSION_TIMEOUT_SECONDS) };
    }
  }, [axiosAuthInstance]);

  return {
    insertAcessoApi,
    requeNewPasswordApi,
    validateCodeApi,
    createNewPasswordApi,
    refreshApi,
    fetchSessionConfigApi,
  };
};